import { Component, inject } from '@angular/core';

import { TranslationService } from '../../../shell/translation-service';
import { ModuleHeader } from '../../layout/module-header/module-header';

@Component({
  selector: 'ima-placeholder-page',
  imports: [ModuleHeader],
  templateUrl: './placeholder-page.html',
  styleUrl: './placeholder-page.scss',
})
export class PlaceholderPage {
  protected readonly i18n = inject(TranslationService);
}
